import { SET_NETWORK_MODE } from "@/redux/types";

export const setNetworkMode = (mode) => ({
    payload: { mode },
    type: SET_NETWORK_MODE,
});
